import { Link } from '@tanstack/react-router';
import { useStatusOptions } from '@/hooks/useStatusOptions';
import { cn } from '@/helpers/classnames';
import { OrganizationApplicationDTO } from '@/api/trafikportalen';
import { formatDate } from '@/helpers/formatting';
import { useTenantID } from '@/hooks/useTenantID';

interface ApplicationListItemProps {
  application: OrganizationApplicationDTO;
}

export const ApplicationListItem = ({
  application,
}: ApplicationListItemProps) => {
  const tenantId = useTenantID();
  const getStatus = useStatusOptions();

  const status = getStatus({ status: application.status });

  return (
    <div className="relative flex @container">
      <Link
        className="flex w-full flex-wrap items-center rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm hover:bg-background-200 @2xl:grid @2xl:grid-cols-12 lg:text-base"
        to="/$tenantId/organizations/applications/$applicationId"
        params={{ tenantId, applicationId: application.id }}
      >
        <div className="flex w-full flex-col @2xl:col-span-4 @2xl:w-auto">
          <span className="truncate pr-6 font-medium">{application.name}</span>
          <span>{application.organization_number}</span>
        </div>
        <div className="flex w-full flex-col gap-1 text-nowrap @2xl:flex-row @2xl:justify-between">
          <span>{formatDate(application.created_at)}</span>
        </div>
      </Link>
      <div
        className={cn(
          'absolute right-4 top-4 flex size-3 flex-row rounded-full @2xl:right-4 @2xl:top-1/2 @2xl:-translate-y-1/2',
          status ? status.style : 'bg-background-500',
        )}
      />
    </div>
  );
};
